<script>
    $: active = 0
    /* 
    　1:国産のみ
      2:輸入のみ
      3:どっちも
    */
    const items = [
        {
            name:"皮むき",
            img:"img/products/pic_cut_illust_01.png",
            desc:"お好きな用途でご使用ください。",
            products:[
                {
                    name:"じゃがいも",
                    img:"img/products/AdobeStock_296477754.png",
                    type:1
                },
                {
                    name:"にんじん",
                    img:"img/products/AdobeStock_219504907.png",
                    type:3
                },
                {
                    name:"里芋",
                    img:"img/products/AdobeStock_384934254.png",
                    type:1
                },{
                    name:"大根",
                    img:"img/products/AdobeStock_82271450.png",
                    type:1
                },{
                    name:"かぶ",
                    img:"img/products/23044565_m.png",
                    type:1
                },
                {
                    name:"さつまいも",
                    img:"img/products/AdobeStock_226537970.png",
                    type:1
                },
                {
                    name:"かぼちゃ",
                    img:"img/products/AdobeStock_123556692.png",
                    type:3
                },
                {
                    name:"たまねぎ",
                    img:"img/products/AdobeStock_246222903.png",
                    type:3
                },

            ]
        },
        {
            name:"乱切り",
            img:"img/products/image_cut_illust_02.png",
            desc:"シチュー、煮もの、酢豚などの炒めものなどにご使用いただけます。",
            products:[
            
            {
                    name:"じゃがいも",
                    img:"img/products/AdobeStock_296477754.png",
                    type:1
                },
                {
                    name:"にんじん",
                    img:"img/products/AdobeStock_219504907.png",
                    type:3
                },
                {
                    name:"里芋",
                    img:"img/products/AdobeStock_384934254.png",
                    type:1
                },{
                    name:"大根",
                    img:"img/products/AdobeStock_82271450.png",
                    type:1
                },{
                    name:"かぶ",
                    img:"img/products/23044565_m.png",
                    type:1
                },
                {
                    name:"さつまいも",
                    img:"img/products/AdobeStock_226537970.png",
                    type:1
                },
                {
                    name:"かぼちゃ",
                    img:"img/products/AdobeStock_123556692.png",
                    type:3
                },
                {
                    name:"なす",
                    img:"img/products/AdobeStock_274809023.png",
                    type:1
                },
                {
                    name:"たまねぎ",
                    img:"img/products/AdobeStock_246222903.png",
                    type:3
                },{
                    name:"ピーマン",
                    img:"img/products/AdobeStock_378701617.png",
                    type:1
                },]
        },
        {
            name:"いちょう切り",
            img:"img/products/image_cut_illust_03.png",
            desc:"カレー、炒めもの、煮込みなどにご使用いただけます。",
            products:[            
            {
                    name:"じゃがいも",
                    img:"img/products/AdobeStock_296477754.png",
                    type:1
                },
                {
                    name:"にんじん",
                    img:"img/products/AdobeStock_219504907.png",
                    type:3
                },
                {
                    name:"里芋",
                    img:"img/products/AdobeStock_384934254.png",
                    type:1
                },{
                    name:"大根",
                    img:"img/products/AdobeStock_82271450.png",
                    type:1
                },{
                    name:"かぶ",
                    img:"img/products/23044565_m.png",
                    type:1
                },
                {
                    name:"さつまいも",
                    img:"img/products/AdobeStock_226537970.png",
                    type:1
                },
                {
                    name:"かぼちゃ",
                    img:"img/products/AdobeStock_123556692.png",
                    type:3
                },
                {
                    name:"なす",
                    img:"img/products/AdobeStock_274809023.png",
                    type:1
                },
                {
                    name:"たまねぎ",
                    img:"img/products/AdobeStock_246222903.png",
                    type:3
                }]
        },
        {
            name:"角切り",
            img:"img/products/image_cut_illust_04.png",
            desc:"カレー、クラムチャウダー、サラダなどにご使用いただけます。",
            products:[            
            {
                    name:"じゃがいも",
                    img:"img/products/AdobeStock_296477754.png",
                    type:1
                },
                {
                    name:"にんじん",
                    img:"img/products/AdobeStock_219504907.png",
                    type:3
                },{
                    name:"大根",
                    img:"img/products/AdobeStock_82271450.png",
                    type:1
                },
                {
                    name:"さつまいも",
                    img:"img/products/AdobeStock_226537970.png",
                    type:1
                },
                {
                    name:"かぼちゃ",
                    img:"img/products/AdobeStock_123556692.png",
                    type:3
                },
                {
                    name:"たまねぎ",
                    img:"img/products/AdobeStock_246222903.png",
                    type:3
                }]
        },
        {
            name:"拍子切り",
            img:"img/products/image_cut_illust_05.png",
            desc:"炒めもの、煮ものなどにご使用いただけます。",
            products:[{
                    name:"大根",
                    img:"img/products/AdobeStock_82271450.png",
                    type:1
                }]
        },
        {
            name:"くし切り",
            img:"img/products/image_cut_illust_06.png",
            desc:"かぼちゃの天ぷら、ソテーなどにご使用いただけます。",
            products:[{
                    name:"かぶ",
                    img:"img/products/23044565_m.png",
                    type:1
                },
                {
                    name:"かぼちゃ",
                    img:"img/products/AdobeStock_123556692.png",
                    type:3
                },
                {
                    name:"たまねぎ",
                    img:"img/products/AdobeStock_246222903.png",
                    type:3
                }]
        },
        {
            name:"短冊切り",
            img:"img/products/image_cut_illust_07.png",
            desc:"汁もの、八宝菜などの炒めものなどにご使用いただけます。",
            products:[                {
                    name:"にんじん",
                    img:"img/products/AdobeStock_219504907.png",
                    type:3
                },{
                    name:"大根",
                    img:"img/products/AdobeStock_82271450.png",
                    type:1
                },{
                    name:"ピーマン",
                    img:"img/products/AdobeStock_378701617.png",
                    type:1
                },]
        }
    ]
</script>
<div class="wrapper">
    <ul class="tabs">
        {#each items as item,i}
            <li on:click={()=>{active = i}} class={active == i ? "active" : ""}>
               {item.name}
            </li>
        {/each}
    </ul>
    <div class="main">
        <div class="desc">
            <img src={items[active].img} alt="">
            <div class="txt">
                <h4>{items[active].name}</h4>
                <p>{items[active].desc}</p>
            </div>
        </div>
        <div class="products">
            {#each items[active].products as item,i}
                <div class="item">
                    <img src={item.img} alt="">
                    <div class="ttl">
                        <p>{item.name}</p>
                        <div class="type">
                            {#if item.type == 1}
                            <div class="type1"><img src="img/products/type1.svg" alt="">国産</div>
                            {:else if item.type == 2}
                            <div class="type2"><img src="img/products/type2.svg" alt="">輸入</div>
                            {:else}
                            <div class="type1"><img src="img/products/type1.svg" alt="">国産</div>
                            <div class="type2"><img src="img/products/type2.svg" alt="">輸入</div>
                            {/if}
                        </div>
                    </div>
                </div>
            {/each}
        </div>
    </div>
</div>
<style>
    .wrapper{
        padding: 0;
        margin: 0;
        width: 100%;
    }
    .tabs{
        display: flex;
        border-bottom: 5px solid #FF9B11;
        justify-content: space-between;
        padding: 0;
        width: 100%;
    }
    .tabs li{
        box-sizing: border-box;
        width: 148px;
        height: 65px;       
        border: 2px solid #9B9B9B;
        border-radius: 10px 10px 0px 0px;
        font-family: 'Noto Sans JP';
        font-style: normal;
        font-weight: 700;
        font-size: 20px;
        color: #9B9B9B;
        display: flex;
        align-items: center;
        justify-content: center;
        list-style: none;
        border-bottom: none;
        cursor: pointer;
    }
    .tabs li.active{
        color: #FFF;
        background: #FF9B11;
        border: 2px solid #FF9B11;
        border-bottom:none;
    }
    .tabs li:hover{
        border: 2px solid #FF9B11;
        color: #FF9B11;
        border-bottom:none;
    }
    .tabs li.active:hover{
        color: #FFF;
    }
    .main .desc{
        box-sizing: border-box;
        background: #FFF1DB;
        width: 100%;
        height: 252px;
        display: flex;
        align-items: center;
        margin-bottom: 37px;
    }
    .desc img{
        margin-left: 170px;
    }
    .desc .txt{
        margin-left: 32px;   
    }
    .desc .txt h4{
        font-family: 'Noto Sans JP';
        font-style: normal;
        font-weight: 700;
        font-size: 20px;
        line-height: 20px;
        color: #000000;
    }
    .desc .txt p{
        font-family: 'Noto Sans JP';
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 36px;
        color: #000000;
    }
    .products{
        display: flex;
        gap: 40px 22px;
        flex-wrap: wrap;
    }
    .products .ttl p{
        font-family: 'Noto Sans JP';
        font-style: normal;
        font-weight: 700;
        font-size: 28px;
        line-height: 28px;
        color: #000000;
        margin: 0;
        padding: 0;
    }
    .products .ttl{
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
    }
    .type{
        display: flex;
        gap: 4px;
    }
    .type1{
        background: #FFFFFF;
        border: 1px solid #FF3E3E;
        border-radius: 80px;
        font-family: 'Noto Sans JP';
        font-style: normal;
        width: 80px;
        font-weight: 500;
        font-size: 16px;
        line-height: 26px;
        display: flex;
        align-items: center;
        color: #000000;
    }
    .type1 img{
        margin-left: 15px;
        margin-right: 8px;
    }
    .type2{
        background: #FFFFFF;
        border: 1px solid #1DA4F8;
        border-radius: 80px;
        font-family: 'Noto Sans JP';
        font-style: normal;
        width: 80px;
        font-weight: 500;
        font-size: 16px;
        line-height: 26px;
        display: flex;
        align-items: center;
        color: #000000;
    }
    .type2 img{
        margin-left: 15px;
        margin-right: 8px;
    }
    .main{
        min-height: 1700px;
    }
    @media screen and (max-width:640px){
        .wrapper{
            overflow-x: scroll;
            overflow-y: hidden;
            min-height: 3700px;
            position: relative;
        }
        .tabs{
            display: flex;
            border-bottom: 5px solid #FF9B11;
            justify-content: space-between;
            padding: 0;
            width: 588px;
        }
        .tabs li{
            font-size: 12px;
            width: 84px;
            height: 34px;
        }
        .main{
            position: sticky;
            left: 0;
        }
        .main .desc{
            flex-direction: column;
            height: auto;
            padding-top:20px;
            padding-bottom: 20px;
        }
        .main .desc img{
            margin:20px 0;
        }
        .main .txt{
            margin: 0;
            width: 300px;
        }
        .main .desc h4{
            margin: 0;
            font-size: 16px;
        }
        .main .desc p{
            font-size: 12px;
            line-height: 16px;
        }
        .main .item{
            margin: auto;
        }
        .main .products .ttl p{
            font-size: 22px;
            line-height: 22px;
        }
        .products .item{
            max-width: 100%;
        }
        .products .item>img{
            width: 100%;
            max-width: 360px;
        }
    }
</style>